import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { FaLock, FaPiggyBank } from 'react-icons/fa';
import { CarryoverFundsManager } from '../components/admin/CarryoverFundsManager';

export const CarryoverFundsPage: React.FC = () => {
  const { canWrite } = usePermissions();
  
  // 관리자만 접근 가능
  const canManageCarryover = canWrite('finance');

  // 권한 없을 때 표시
  if (!canManageCarryover) {
    return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <FaLock className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-600 dark:text-gray-400">접근 권한이 없습니다</h2>
          <p className="text-gray-500 dark:text-gray-500">이월예산관리는 관리자만 접근 가능합니다.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-emerald-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* 페이지 헤더 - 다른 페이지와 통일성 유지 */}
        <div className="flex items-center mb-8">
          <FaPiggyBank className="text-3xl text-gray-600 dark:text-gray-200 mr-4" />
          <div>
            <h1 className="text-3xl font-bold text-gray-600 dark:text-gray-200">이월예산관리</h1>
            <p className="ml-1 mt-1 text-md text-gray-500 dark:text-gray-400">전년도 이월 예산을 관리하고 추적합니다.</p>
          </div>
        </div>

        {/* 이월예산관리 컴포넌트 */}
        <CarryoverFundsManager />
      </div>
    </div>
  );
};